export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_08.bae165f5.jpg";